<template>
  <el-dialog
    class="cancel-subscription-dialog"
    fullscreen
    :visible.sync="dialogVisible"
    append-to-body
    destroy-on-close
    :show-close="false"
  >
    <hidden-header-layout>
      <div class="cancel-subscription-dialog__content">
        <div class="cancel-subscription-dialog__content__close-button" @click="onCloseDialog">
          <img :src="require('@/assets/images/close-button.svg')" />
        </div>
        <iframe ref="iFrame" :src="cancellationUrl" class="mt-3 w-full bg-gray" scrolling="no"></iframe>

        <section class="cancel-subscription-dialog__section">
          <el-form class="mt-2" ref="form" :model="form" label-position="top" :rules="rules">
            <el-form-item
              class="black"
              prop="cancelReason"
              :label="$t('ec-line015.cancelSubscriptionDialog.form.label1')"
              required
            >
              <el-select v-model="form.cancelReason" clearable>
                <el-option v-for="item in cancellationReasons" :key="item.id" :label="item.name" :value="item.id" />
              </el-select>
            </el-form-item>
            <el-form-item
              class="black"
              prop="cancelReasonDetail"
              :label="$t('ec-line015.cancelSubscriptionDialog.form.label2')"
              required
            >
              <el-input
                v-model="form.cancelReasonDetail"
                :placeholder="$t('ec-line015.cancelSubscriptionDialog.sectionAdd.textAreaPlaceholder')"
                type="textarea"
                :rows="5"
              />
            </el-form-item>
          </el-form>
          <div class="w-full flex flex-col items-center lg:flex-row justify-center">
            <el-button class="cancel-btn mt-8 lg:mt-0 lg:mx-2" @click="onSubmit">
              {{ $t('ec-line015.cancelSubscriptionDialog.sectionAdd.btn') }}
            </el-button>
            <el-button class="cancel-btn my-8 lg:mx-2" @click="onCloseDialog">{{
              $t('ec-line015.cancelSubscriptionDialog.sectionAdd.cancelBtn')
            }}</el-button>
          </div>
        </section>
      </div>
    </hidden-header-layout>
    <confirm-dialog
      :visible.sync="confirmCancelSubscriptionDialog"
      :title="$t('ec-line015.content.cancelSection.confirmCancelTitle')"
      :content="cancelContent"
      @on-accept="onAcceptCancelSubscription"
    />
  </el-dialog>
</template>

<script>
import HiddenHeaderLayout from '@/layouts/HiddenHeaderLayout.vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import { ENV_KEY } from '@/constants/env'

const DEFAULT_FORM = () => ({
  cancelReason: '',
  cancelReasonDetail: '',
})

export default {
  name: 'CancelSubscriptionDialog',
  components: { HiddenHeaderLayout, ConfirmDialog },
  props: {
    visible: Boolean,
    data: {
      type: Array,
      required: false,
      default: () => [],
    },
    cancellationReasons: {
      type: Array,
      required: true,
      default: () => [],
    },
    cancelContent: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      selected: null,
      confirmCancelSubscriptionDialog: false,
      form: DEFAULT_FORM(),
      scroll: '',
      rules: {
        cancelReason: [
          this.Utils.validate.requiredSelect(this.$t('ec-line015.cancelSubscriptionDialog.form.label1Validate')),
        ],
        cancelReasonDetail: [
          this.Utils.validate.required(this.$t('ec-line015.cancelSubscriptionDialog.form.label2Validate')),
        ],
      },
      cancellation: '',
      listener: null,
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(value) {
        this.$emit('update:visible', value)
      },
    },
    cancellationUrl() {
      return `${this.$store.getters['env/GET_KEY'](ENV_KEY.BASE_URL)}${this.Constants.SHOP_CONFIG.CANCELLATION}`
    },
  },
  mounted() {
    const that = this
    this.listener = window.addEventListener('message', (e) => {
      if (e.data.event === 'close-dialog') {
        that.onCloseDialog()
      }
      if (e.data.event === 'close-dialog1') {
        that.scrollSubscription()
        that.onCloseDialog()
      }
      if (e.data.event === 'close-dialog2') {
        that.scrollPurchaseDetails()
        that.onCloseDialog()
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('message', this.listener)
  },

  watch: {
    dialogVisible(val) {
      if (val) {
        this.resizeIFrameToFitContent()
      }
    },
  },
  methods: {
    scrollPurchaseDetails() {
      this.$emit('scroll-purchaseDetails', (this.scroll = 'purchaseDetails'))
    },
    scrollSubscription() {
      this.$emit('scroll-subscription', (this.scroll = 'subscription'))
    },
    onCloseDialog() {
      this.dialogVisible = false
    },
    onSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.confirmCancelSubscriptionDialog = true
      })
    },
    onAcceptCancelSubscription() {
      this.$emit('on-cancel-subscription', this.form)
      this.onCloseDialog()
      this.form = DEFAULT_FORM()
    },
    resizeIFrameToFitContent() {
      this.$nextTick(() => {
        let iframe = this.$refs.iFrame

        if (iframe) {
          iframe.onload = () => {
            iframe.removeAttribute('style')
            iframe.style.height = 'calc(' + iframe.contentWindow.document.body.scrollHeight + 'px + ' + '16px)'
          }
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/css/components/ec-line015/cancel-subscription-dialog.scss';
</style>
